import * as React from "react";
import { connect } from "react-redux";
import AlbusApis from "../../js/api/AlbusApis";
import { ModalActions } from "../actions/ModalActions";
import { IAppState } from "../models/IAppState";
import IQuestionnaire from "../models/util/IQuestionnaire";
import { FieldTypes, modalTypes } from "../utils/AppConstants";
import CollapsibleCardView from "./CollapsibleCardView";
import Questionnaire from "./common/Questionnaire";
import { ModalComponent } from "./ModalComponent";
import CustomHeader from "./utils/CustomHeader";

interface ModalComponentDispatchProps {
    toggleShowModal: (showModal: boolean) => void,
    updateModalUIConfig: (formattedConfigAvailable: boolean) => void,
    updateModalConfig: (response: any) => void,
    showPatientPastSessions: (responseData: any[]) => void,
    updateFormattedDataAvailable: (formattedConfigAvailable: boolean) => void,
    addSymptomForReview: (name: string) => Promise<any>,
    addButtonClicked: (status: boolean, name: string) => Promise<any>
}

interface ModalComponentStateToProps {
    showModal: boolean,
    responseData: any,
    formattedConfigAvailable: boolean,
    modalUIConfig: any,
}   

export interface ModalComponentProps {
    modalSize: string,
    children?: any,
    onClickCloseHandler?: () => void,
    onClickPreventCloseHandler?: (event: any) => void,
    toggleModal?: () => void,
    keepPadding?: boolean,
    updatedObject?: any;
    updateHandler?: (updatedObject: any) => void,
    hideComment?: boolean
    itemRemove?: (updatedObject: any) => void,
    widgetData?: any,
    modalHeaders?: []
}

class GenericModal extends React.Component<ModalComponentProps & ModalComponentDispatchProps & ModalComponentStateToProps> {
    constructor(props: ModalComponentProps & ModalComponentDispatchProps & ModalComponentStateToProps) {
        super(props);
    }

    toggleModal = () => {
        //this.props.onClickCloseHandler ? this.props.onClickCloseHandler() : undefined;
        this.props.toggleShowModal(false);
        this.props.updateFormattedDataAvailable(false);
    }

    updateHandler = (value: any, key: string, field?: any) => {
        let updatedObject = { ...this.props.updatedObject, [key]: value };
        this.props.updateHandler(updatedObject);
    }
    itemChanged = (updatedValue: any, index: number, key: string, field?: any) => {
        let updatedObject = { ...this.props.updatedObject };
        if (key) {
            if (!updatedObject[key]) {
                updatedObject[key] = [];
            }
            updatedObject[key][index] = updatedValue.item;
            this.props.updateHandler(updatedObject);
        }

    }
    itemRemove = (index: number, key: string) => {
        let updatedObject: any = { ...this.props.updatedObject };
        updatedObject[key].splice(index, 1);
        this.props.updateHandler(updatedObject);
    }

    convertConfigForViewOnly = (field: any) => {
        if (field.type === FieldTypes.TEMPLATED_LIST || field.type === FieldTypes.TEMPLATED_LIST_V3) {
            field.templatedListConfiguration = {
                autoAddNewRow: false,
                hideRemoveBtn: true,
                preventRowAddition: true,
            }
            if (field.fields) {
                field.fields.map((subField: any) => {
                    this.convertConfigForViewOnly(subField);
                })
            }
        }
    }

    stopEventPropagation = (event: any) => {
        event.stopPropagation();
    }

    componentDidUpdate() {
        let modalUIConfigViewOnly: any[] = this.props.showModal && !this.props.formattedConfigAvailable && this.props.modalUIConfig && this.props.modalUIConfig.data && this.props.modalUIConfig.data.map((uiConfig: any) => {
            uiConfig.answerList.map((field: any) => {
                this.convertConfigForViewOnly(field);
            })
            return uiConfig;
        });

        if (modalUIConfigViewOnly) {
            this.props.updateModalUIConfig({ ...this.props.modalUIConfig, data: modalUIConfigViewOnly });
            this.props.updateFormattedDataAvailable(true);
        }
    }

    okCallBack = async (event: any) => {
        let getData = this.props.modalUIConfig.modalData;
        this.props.addButtonClicked(true, getData);
     
        // let objKey = Object.keys(this.props.modalUIConfig.updatedObject);
        // let modalData = getData[objKey[0]];
        // let getVal = '';
        // modalData.forEach(function (ele: any) {
        //     getVal = ele;
        // })
        this.toggleModal();
        await AlbusApis.addSymptomForReview(getData);
    }

    cancelCallBack = () => {
        let getData = this.props.modalUIConfig.modalData;
        this.props.addButtonClicked(false, getData);
        this.toggleModal();

    }


    render() {
        let noPadding = this.props.keepPadding !== undefined && !this.props.keepPadding ? "noPadding" : "";
        let modalCssClasses = `modal-content full ${this.props.modalSize} ${noPadding}`;
        let noOfSessions = this.props.responseData && this.props.responseData.data ? this.props.responseData.data.length : 0;
        let modalTitle = this.props.modalUIConfig && this.props.modalUIConfig.subSectionTitle;
        let modalType = this.props.modalUIConfig && this.props.modalUIConfig.modalType;
        let padding = this.props.keepPadding !== undefined ? this.props.keepPadding : true;
        let getVal = "";
        if (modalType === modalTypes.CONFIRMATION_MODAL) {
            getVal = this.props.modalUIConfig && this.props.modalUIConfig.modalData;
        }

        let customHeaders: any[] = this.props.modalUIConfig && this.props.modalUIConfig.modalHeaders ? this.props.modalUIConfig.modalHeaders : [];

        return this.props.showModal ? (
           modalType == undefined || modalType === modalTypes.PAST_SESSION_MODAL ?
                <div className="modal-backdrop" onClick={this.toggleModal}>
                    <div className="modal-container">
                        <div className={modalCssClasses}>
                            {this.props.responseData && this.props.responseData.length > 0 ?
                                <CollapsibleCardView titleComponent={<div>{modalTitle}</div>}>
                                    <div onClick={this.stopEventPropagation}>
                                        {this.props.modalUIConfig && this.props.modalUIConfig.data && this.props.responseData && this.props.responseData.map((dataObj: any, index: number) => {
                                            const modalHeaders = customHeaders.length > 0 ? customHeaders.map((header: any) => ({ ...header, value: dataObj[header.valueKey] })) : [];
                                            return this.props.modalUIConfig.data.map((uiConfig: IQuestionnaire, index: number) => {
                                                let key = uiConfig.key ? uiConfig.key : uiConfig.answerList && uiConfig.answerList[0] && uiConfig.answerList[0].key;
                                                let answer = key && dataObj[key] ? dataObj[key] : null;
                                                return <div key={index} className="physical-assessment-editor">
                                                    {index === 0 && <CustomHeader headerInfos={modalHeaders} rootCls={"physical-assessment"} />}
                                                    <Questionnaire question={uiConfig} answer={answer} hideComment={true} />
                                                </div>
                                            })
                                        })
                                        }
                                    </div>
                                    <button className="close-button" onClick={this.toggleModal}>
                                          <span className="cross-line cross-line-left"></span>
                                          <span className="cross-line cross-line-right"></span>
                                        {/* <img src="../../../../images/icons/path-copy.svg"></img> */}
                                    </button>
                                </CollapsibleCardView>
                                : <div className="modal-message">No Past Sessions Data Available</div>}


                        </div>
                    </div>
                </div> :
                <ModalComponent modalSize={"x-small"} keepPadding={padding}>
                    <div className={"error-top-container animated slideInDown"}>
                        <div className={"error-text"}>{this.props.modalUIConfig.modalErrorText}</div>
                        <div className={"error-details"}>{`"${getVal}"`}{this.props.modalUIConfig.modalErrorDetails}</div>
                        <div className={"close-error-message"}>
                            <div className={"button cancel-button"} onClick={this.cancelCallBack}>{this.props.modalUIConfig.modalButtons && this.props.modalUIConfig.modalButtons.cancelButton}</div>
                            <div className={"button ok-button"} onClick={(evt) => this.okCallBack(evt)}> { this.props.modalUIConfig.modalButtons && this.props.modalUIConfig.modalButtons.addNew} </div>
                        </div>
                    </div>
                </ModalComponent>

        ) : <div></div>

    }
}
const mapStateToProps = (state: IAppState): ModalComponentStateToProps => {
    let showModal = state.responseData.showModal;
    let responseData = state.responseData.responseData;
    let modalUIConfig = state.responseData.modalUIConfig;
    let formattedConfigAvailable = state.responseData.formattedConfigAvailable;
    return { showModal, responseData, modalUIConfig, formattedConfigAvailable };
}

const mapDispatchToProps = (dispatch: any): ModalComponentDispatchProps => {
    return {
        toggleShowModal: (toggleModal: boolean) => {
            return dispatch(ModalActions.showModal(toggleModal));
        },
        updateModalConfig: (responseData: any) => {
            return dispatch(ModalActions.responseData(responseData));
        },
        showPatientPastSessions: (responseData: any[]) => {
            return dispatch(ModalActions.showPastSession(responseData));
        },
        updateModalUIConfig: (modalUIConfig: any) => {
            return dispatch(ModalActions.updateModalUIConfig(modalUIConfig))
        },
        updateFormattedDataAvailable: (formattedConfigAvailable: boolean) => {
            return dispatch(ModalActions.updateFormattedDataAvailable(formattedConfigAvailable))
        },
        addSymptomForReview: (name: string) => {
            return dispatch(ModalActions.addSymptomForReview(name))
        },
        addButtonClicked: (status: boolean, name: string) => {
            return dispatch(ModalActions.addButtonClicked(status, name))
        }

    }
}

export default connect<ModalComponentStateToProps, ModalComponentDispatchProps, ModalComponentProps>(mapStateToProps, mapDispatchToProps)(GenericModal)